var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center my-3 text-silver small d-flex flex-row align-items-center"},[_c('hr',{staticClass:"flex-fill"}),_c('span',{staticClass:"mx-2"},[_vm._t("default")],2),_c('hr',{staticClass:"flex-fill"})])}
var staticRenderFns = []

export { render, staticRenderFns }